import { Organization } from "../../../models/organization.model.ts";
import { httpRequest } from "../../http";

export class CommandUpdateOrganization {
    async run(organizationForm: Organization) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationForm.id}`
        const body = {
            name: organizationForm.name,
            short_name: organizationForm.short_name,
            description: organizationForm.description,
            site_url: organizationForm.site_url
        }

        try {
            const response = await httpRequest<any>(url, { method: "PUT", body });
            return response;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async setParent(orgId: number, parentId: number | null) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${orgId}`;
        const response = await httpRequest<any>(url, {
            method: "PUT",
            body: { parent_id: parentId },
        });
        return response;
    }
}



